import Api from '@/lib/api/api';
import v5_Model from '@/models/v5/model';
import counts_collection from '@/collections/v5/counts';
import DraftsCollection from '@/collections/v5/drafts';
import Devcounts from '@/models/v5/devcounts';

function create_drafts(product) {
    return new DraftsCollection(null, {
        product: product
    });
}

const Product = v5_Model.extend({
    initialize: function() {
        this.type = Product.type;
        this.drafts = create_drafts(this);
        this.counts = counts_collection.create_counts_model_for(
            this, Api.urls.product_counts, 'development_devicegroup'
        );
        this.devcounts = new Devcounts({product: this});
    }
});
Product.type = 'product';

export default Product;

